const fonts = [
  {
    font: "Roboto",
    weights: [400],
  },
  {
    font: "Montserrat",
    weights: [400],
  },
  {
    font: "Reem Kufi",
    weights: [400],
  },
  {
    font: "Bebas Neue",
    weights: [400],
  },
  {
    font: "Dancing Script",
    weights: [400],
  },
  {
    font: "Lobster",
    weights: [400],
  },
  {
    font: "Caveat",
    weights: [400],
  },
  {
    font: "Shadows Into Light",
    weights: [400],
  },
  {
    font: "Abril Fatface",
    weights: [400],
  },
  {
    font: "Arvo",
    weights: [400],
  },
];

export default fonts;
